/**
 * CollectionWriteOffRequest permissions — operational write-off (Batch 5-A).
 */

export const COLLECTION_WRITEOFF_READ_PERMISSION = 'collection_writeoff:read' as const;
export const COLLECTION_WRITEOFF_CREATE_PERMISSION = 'collection_writeoff:create' as const;
export const COLLECTION_WRITEOFF_SUBMIT_PERMISSION = 'collection_writeoff:submit' as const;
export const COLLECTION_WRITEOFF_APPROVE_PERMISSION = 'collection_writeoff:approve' as const;
export const COLLECTION_WRITEOFF_CANCEL_PERMISSION = 'collection_writeoff:cancel' as const;

export const COLLECTION_WRITEOFF_PERMISSIONS = [
  COLLECTION_WRITEOFF_READ_PERMISSION,
  COLLECTION_WRITEOFF_CREATE_PERMISSION,
  COLLECTION_WRITEOFF_SUBMIT_PERMISSION,
  COLLECTION_WRITEOFF_APPROVE_PERMISSION,
  COLLECTION_WRITEOFF_CANCEL_PERMISSION,
] as const;

export type CollectionWriteOffPermission = (typeof COLLECTION_WRITEOFF_PERMISSIONS)[number];

export function isCollectionWriteOffPermission(
  permission: string
): permission is CollectionWriteOffPermission {
  return (COLLECTION_WRITEOFF_PERMISSIONS as readonly string[]).includes(permission);
}
